import Head from "next/head";
import Image from "next/image";
import Layout from "../../../components/Layout";

import AppDetails from "../../../components/AppDetails";
import { AppsData } from "../../../data/AppsData";
import AppContainer from "../../../components/AppContainer";
import React, { useEffect, useState } from "react";
import SEO from "components/seo";
import { useRouter } from "next/router";
import { generateVideoGameSchema } from "data/schemaCodes/gameSchema";
import GoogleAdSenseContainer from "adsenseAds/GoogleAdSenseContainer";
import { adSenseAdUnits } from "utils/variants";
import GameProvider from "src/contexts/GameContext";
import MinimalAppList from "components/AppsList/MinimalAppList";
import Content from "components/Layout/Content";
import FadeTransition from "components/FadeTransition";
import CategoryStrip from "components/CategoryStrip";
import { gameContent } from "data/gameContent";
import HideOnWWW from "components/HideOnWWW";
import { isWWW } from "utils/env";
import { mangaQuizGame } from "data/manga-quiz";
// get staticpaths
export async function getStaticPaths() {
  const games = [...AppsData];
  if (!isWWW) games.push(mangaQuizGame);
  const paths = games.map(game => {
    return {
      params: { game: game.pathname },
    };
  });
  return {
    paths,
    fallback: false,
  };
}

// get staticprops

export async function getStaticProps({ params }) {
  const games = [...AppsData];
  if (!isWWW) games.push(mangaQuizGame);
  const game = JSON.parse(
    JSON.stringify(games.find(game => game.pathname === params.game))
  );
  return {
    props: {
      game,
    },
  };
}
export default function GameDetails({ game }) {
  const router = useRouter();
  const similarGames = AppsData.filter(g => g.pathname !== game.pathname);

  const schemaCodes = [
    {
      type: "application/ld+json",
      code: JSON.stringify(generateVideoGameSchema(game)),
    },
  ];

  return (
    <>
      <SEO
        url={router.pathname}
        title={game.meta.title}
        description={game.meta.description}
        schemaCodes={schemaCodes}
        useTitleTemplate={false}
        image={game.meta.image}
      />
      <CategoryStrip />
      <HideOnWWW>
        <div className="m-auto min-h-[300px]">
          <GoogleAdSenseContainer {...adSenseAdUnits.atfGameDetails} adCheck />
        </div>
      </HideOnWWW>
      <GameProvider>
        <AppContainer item={game} similarGames={similarGames} />
      </GameProvider>
      <HideOnWWW>
        <GoogleAdSenseContainer {...adSenseAdUnits.btfGameDetails} adCheck />
      </HideOnWWW>
      <AppDetails item={game} />
    </>
  );
}
GameDetails.getLayout = function getLayout(page) {
  return <Layout noFooterBg>{page}</Layout>;
};
